export default {
    allSet: (state, getters, rootState) => {
        return rootState.preferences.every(preference => {
            return preference.responses.some(response => response.selected)
        })
    },
    all: (state, getters, rootState) => {
        let preferences = []
        try {
            preferences = rootState.preferences
        }
        catch (e) {}
        return preferences
    },
    current: (state, getters, rootState, rootGetters) => {
        let preference = {}
        try {
            preference = rootState.preferences.find(preference => preference.name === rootState.route.params.panels_name) || {}
        }
        catch (e) {}
        return preference
    },
    get: (state, getters, rootState, rootGetters) => (name) => {
        let preference = {}
        try {
            preference = rootState.preferences.find(p => p.name === name) || {}
        }
        catch (e) {}
        return preference
    },
    getResponse: (state, getters, rootState, rootGetters) => (name, response) => {
        let resp = {}
        try {
            let panel = rootState.preferences.find(p => p.name === name) || {}
            if (['value', 'date'].includes(panel.type)) {
                resp = panel.responses[0]
            }
            else {
                resp = panel.responses.find(r => r.value === response) || {}
            }
        }
        catch (e) {}
        return JSON.parse(JSON.stringify(resp))
    },
    getOrder: (state, getters, rootState) => {
        /*
        Used to find the order for the bottom bar for preferences.
        Language and Location preferences are handled via other means so this
        logic will return the index and total only for preference *panels* and 0 otherwise
        */
        const ind = getters.all.findIndex(pref => pref.name === getters.current.name);

        return {
            total: getters.all.length,
            ind: Math.max(0, ind),
        }
    },
    getHeartRateInputMethod: (state, rootState) => {
        const prefHr = state.heartRateInputMethod;
        const hrMethod = rootState.settings?.engagements_features?.heartRateInputMethod;
        if (prefHr) return prefHr;
        if (hrMethod) return hrMethod;
        return 'slider';
    },
    getRespiratoryRateInputMethod: (state, rootState) => {
        const prefRr = state.respiratoryRateInputMethod;
        const rrMethod = rootState.settings?.engagements_features?.respiratoryRateInputMethod;
        if (prefRr) return prefRr;
        if (rrMethod) return rrMethod;
        return 'slider';
    },
}
